import { ICustomLanguageDetector } from "@wesr/wesr-common";
import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { fetchContentWithFallback } from "./utils/Content";

// To add a language: append its code here and drop a matching folder under
// `public/locales/<code>/` (or upload to the same path in the content bucket).
const SUPPORTED_LANGUAGES = ["en"] as const;

const resolveSupportedLanguage = (
  language?: string | null,
): (typeof SUPPORTED_LANGUAGES)[number] => {
  const baseLanguage = language?.split("-")[0];
  return SUPPORTED_LANGUAGES.includes(baseLanguage as (typeof SUPPORTED_LANGUAGES)[number])
    ? (baseLanguage as (typeof SUPPORTED_LANGUAGES)[number])
    : "en";
};

const customLanguageDetector: ICustomLanguageDetector = {
  type: "languageDetector",
  async: true,
  detect: callback => {
    const savedLanguage = localStorage.getItem("i18nextLng");
    callback(resolveSupportedLanguage(savedLanguage));
  },
  init: () => {},
  cacheUserLanguage: lng => {
    localStorage.setItem("i18nextLng", resolveSupportedLanguage(lng));
  },
};

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .use(customLanguageDetector) // Use custom language detector
  .use(HttpApi) // Loads translations from your server
  .init({
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    debug: true,
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    backend: {
      // Path is relative; `request` below prepends `CONTENT_BASE_URL` and falls back to origin on failure.
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      request: (_options, url, _payload, callback) => {
        fetchContentWithFallback(url)
          .then(async response => {
            if (!response.ok) {
              callback(null, { status: response.status, data: {} });
              return;
            }
            const data = await response.json();
            callback(null, { status: response.status, data });
          })
          .catch(error => {
            callback(error, null);
          });
      },
    },
  });

export default i18n;
